import { compose, take } from 'ramda';

import { series } from 'app/features/series/selectors';

const numberOfSeriesToDisplay = 6;

const displayedSeries = compose(take(numberOfSeriesToDisplay), series);

export { displayedSeries };
